import React from 'react'
import { Modal, Icon, Text } from '@adc/ui-adc'
import PropTypes from 'prop-types'
import _cx from 'classnames/bind'
import cls from './index.scss'
const cx = _cx.bind(cls)

const wording = {
  tps: {
    title: 'credit bid',
    content: <strong>credit bid</strong>,
  },
  reo: {
    title: 'reserve',
    content: (
      <span>
        <strong>reserve</strong> price
      </span>
    ),
  },
}
// TODO reviste to use Listing reserve for tuple
const ERVLowerModal = ({ trigger, type }) => (
  <Modal
    size='tiny'
    mobileTitleSkin='light'
    fullScreen='mobileOnly'
    elmId='erv_lower_reserve_modal'
    trigger={trigger}
  >
    <Modal.Content>
      <div className={cx('content')}>
        <div className={cx('robot-icon')}>
          <Icon size='huge' color='info' name='robot' iconStyle='light' />
        </div>
        <Text.Header level='3' color='info' align='center'>
          Why's ERV lower than {wording[type].title}?
        </Text.Header>
        <Text>
          We realize the <strong>estimated resale value</strong> is lower than
          the {wording[type].content}. The estimated resale data may be
          incomplete or something might be amiss.
        </Text>
        <Text className='u-mt-1'>
          We suggest you research comparable sales before you bid. You may still
          find it a good buy.
        </Text>
      </div>
    </Modal.Content>
  </Modal>
)

ERVLowerModal.propTypes = {
  trigger: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['tps', 'reo']),
}

export default ERVLowerModal
